import React from 'react';
import PropTypes from 'prop-types';

export const MagmaIcon = ({ width, height, ...props }) => (
  <svg
    data-icon='magma-icon'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <rect
      width={ 24 }
      height={ 24 }
      fill='white'
      rx={ 12 }
    />
    <path
      fill='url(#paint0_linear_24_3171)'
      d='M11.315 22s-9.75-3.57-3.662-14.667c0 0-.575 3.855.43 6.182 1.004 2.327 2.383 4.315 3.232 8.485Z'
    />
    <path
      fill='url(#paint1_linear_24_3171)'
      d='M13.059 22a8.827 8.827 0 0 0 3.095-1.97 8.756 8.756 0 0 0 2.172-3.44 9.09 9.09 0 0 0 .03-5.207 10.953 10.953 0 0 0-1.634-3.605 14.262 14.262 0 0 1-.5 5.307c-.443 1.492-.94 2.179-1.69 4.053A29.621 29.621 0 0 0 13.058 22Z'
    />
    <path
      fill='url(#paint2_linear_24_3171)'
      d='M12.443 18.445c.346 0 .567-.75 1.193-2.384.402-1.046.563-1.313.738-1.822.203-.553.368-1.12.494-1.698a14.83 14.83 0 0 0-.037-6.735 9.6 9.6 0 0 0-1.261-2.65c-.51-.75-.768-1.124-1.14-1.154-.988-.08-2.04 2.34-2.477 3.897-.551 2.288-.5 4.682.148 6.943.224.726.553 1.591.553 1.591.244.635.386.846.66 1.628.582 1.538.767 2.377 1.13 2.384Z'
    />
    <defs>
      <linearGradient
        id='paint0_linear_24_3171'
        x1={ 5.718 }
        x2={ 12.68 }
        y1={ 10.439 }
        y2={ 21.225 }
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#631101' />
        <stop
          offset={ 0.16 }
          stopColor='#BB1E00'
        />
        <stop
          offset={ 0.42 }
          stopColor='#F95C04'
        />
        <stop
          offset={ 0.69 }
          stopColor='#FEB400'
        />
        <stop
          offset={ 1 }
          stopColor='#E9D776'
        />
      </linearGradient>
      <linearGradient
        id='paint1_linear_24_3171'
        x1={ 18.891 }
        x2={ 11.987 }
        y1={ 10.222 }
        y2={ 20.974 }
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#631101' />
        <stop
          offset={ 0.16 }
          stopColor='#BB1E00'
        />
        <stop
          offset={ 0.42 }
          stopColor='#F95C04'
        />
        <stop
          offset={ 0.69 }
          stopColor='#FEB400'
        />
        <stop
          offset={ 0.96 }
          stopColor='#E9D776'
        />
      </linearGradient>
      <linearGradient
        id='paint2_linear_24_3171'
        x1={ 12.397 }
        x2={ 12.397 }
        y1={ 4.054 }
        y2={ 20.44 }
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#631101' />
        <stop
          offset={ 0.16 }
          stopColor='#BB1E00'
        />
        <stop
          offset={ 0.42 }
          stopColor='#F95C04'
        />
        <stop
          offset={ 0.69 }
          stopColor='#FEB400'
        />
        <stop
          offset={ 1 }
          stopColor='#E9D776'
        />
      </linearGradient>
    </defs>
  </svg>
);

MagmaIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

MagmaIcon.defaultProps = {
  width: 24,
  height: 24,
};
